import { render, staticRenderFns } from "./MdssResultDetailModal.vue?vue&type=template&id=af90accc&scoped=true"
import script from "./MdssResultDetailModal.vue?vue&type=script&lang=js"
export * from "./MdssResultDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MdssResultDetailModal.vue?vue&type=style&index=0&id=af90accc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af90accc",
  null
  
)

export default component.exports